import { ButtonProps, FlexProps, TextProps } from '@chakra-ui/react';
import { BillGroupDunningStatusEnum } from '@monetize/types/app';
import { MButton, MFlex, MText } from '../../../../components/Monetize';
import { DunningActions } from './DunningActions';

interface SectionHeaderProps extends FlexProps {
  label: string;
  textProps?: TextProps;
  editButtonProps?: ButtonProps;
  saveButtonProps?: ButtonProps;
  isEditMode?: boolean;
  isLoading?: boolean;
  canEdit?: boolean;
  dunningStatus?: BillGroupDunningStatusEnum;
  billGroupId?: string;
  additionalButtons?: React.ReactNode;
  onSave?: () => void;
  onEdit?: () => void;
}
export const SectionHeader = ({
  label,
  textProps,
  editButtonProps,
  saveButtonProps,
  isEditMode,
  isLoading,
  canEdit,
  dunningStatus,
  billGroupId,
  additionalButtons,
  onSave,
  onEdit,
  ...rest
}: SectionHeaderProps) => {
  return (
    <MFlex justify="space-between" align="center" my="6" {...rest}>
      <MText fontSize="lg" fontWeight="600" {...textProps}>
        {label}
      </MText>

      {canEdit && (
        <MFlex gap={4}>
          {additionalButtons}
          {onEdit && (
            <MButton
              minW={20}
              size="sm"
              isDisabled={isLoading}
              variant={'secondary'}
              onClick={onEdit}
              {...editButtonProps}
            >
              {isEditMode ? 'Cancel' : 'Edit'}
            </MButton>
          )}
          {onSave && isEditMode && (
            <MButton
              minW={20}
              size="sm"
              isDisabled={isLoading}
              isLoading={isLoading}
              variant={'primary'}
              onClick={onSave}
              {...saveButtonProps}
            >
              Save
            </MButton>
          )}
          {dunningStatus &&
            dunningStatus !== BillGroupDunningStatusEnum.GOOD_STANDING && (
              <DunningActions
                billGroupId={billGroupId ?? ''}
                dunningStatus={dunningStatus}
              />
            )}
        </MFlex>
      )}
    </MFlex>
  );
};
